import { Directive, HostListener, AfterContentInit, Input, inject } from '@angular/core';
import { AutoComplete } from 'primeng/autocomplete';
import { Observable } from 'rxjs';
import { HisBackendService } from '../../service/backend/his-backend.service';
import { HisAutoCompleteDefaults } from './his-autocomplete-defaults';

/**
 * Easy way to load a key table into an p-autoComplete component.
 * Also sets default values for p-autoComplete that are universally used in H1.
 */
@Directive( {
    selector: 'p-autoComplete[hisLazyDataSource]',
    exportAs: 'hisLazyDataSource',
    standalone: false
} )
export class HisAutoCompleteLazyDataSourceDirective
    extends HisAutoCompleteDefaults
    implements AfterContentInit {
    private backendService = inject(HisBackendService);
    private autoCompleteRef = inject(AutoComplete, { host: true });

    @Input( 'hisLazyDataSource' ) dataSource: string;
    @Input( 'dropdown' ) dropdown: boolean = false;

    ngAfterContentInit(): void {
        this.initDefaults( this.autoCompleteRef );
        this.autoCompleteRef.dropdown = this.dropdown;

        // make name of data source available to debug panel
        // (needs some trickery to convince the compiler that AutoComplete has a field hisDataSource)
        (this.autoCompleteRef as any).hisDataSource = this.dataSource;
    }
    
    @HostListener( 'onClear' )
    onClear() {
        this.filterValue( { event: { query: null } } );
    }

    // filter the list of objects on the server based on user input in text field
    @HostListener( 'completeMethod', ['$event'] )
    filterValue( event: any ) {
        let query = event.query;
        this.filterValueTypes( query ).subscribe( (data: any[]) => {
            this.refreshSuggestions(data);
        } );
    }

    private filterValueTypes( query: string ): Observable<any[]> {
        let resultTypes = this.backendService.getData( this.expandBackendUrl( this.dataSource ) + this.getDelimter() + 'q=' + encodeURI( query ) + '&l=100' );
        return resultTypes;
    }

    private getDelimter(): string {
        return this.dataSource.includes( '?' ) ? '&' : '?';
    }

    private refreshSuggestions(suggestions: any[]) {
        this.autoCompleteRef.suggestions = suggestions;
    }
}
